export const COPY = {
  loader: {
    message: "Preparing a moment just for us…",
  },
  letter: {
    title: "From My Heart to Yours",
    paragraphs: [
      "We connected on November 3rd,\nin the most unexpected way, through this medium.\nAnd now, here we are — January 3rd.",
      "This journey from November 3rd to January 3rd feels deeply meaningful and very close to my heart. I feel grateful for you — always.",
      "In this short time, we’ve shared so much. Our thoughts. Our plans. Care that felt natural, affection that felt real, and a trust that quietly grew between us.",
      "Just 60 days… yet it feels like so much more. And I truly believe this is only the beginning of our journey together — carrying the same love, care, and trust into everything ahead.",
      "I love you, deeply and endlessly. And I promise to stand by you, to choose you every day, and to do everything I can for you, for the rest of my life. ❤️",
    ],
    button: "Continue",
  },
  counter: {
    message:
      "It began on November 3rd,\nin a way neither of us planned.\n\nAnd now — January 3rd.\nSixty days of connection, closeness, and something real.",
    button: "Begin",
  },
  unlock: {
    title: "Enter Your Code",
    hint: "The date that started it all",
    placeholder: "",
    wrongAttempt: "That's not it. Try again.",
  },
  success: {
    message: "You've unlocked something personal",
    subtext: "A timeline of us, just for you",
    button: "Continue",
  },
  hero: {
    heading: "60 Days",
    subtext:
      "Sixty days of quiet beginnings.\nMoments that slowly felt like home.\nAnd a connection worth choosing every day.",
    button: "Continue",
  },
  timeMeaning: {
    title: "60 Days Measured",
    subtitle: "Measured in moments, not just time.",
    metrics: [
      {
        value: 60,
        label: "Days",
        caption: "Conversations that slowly became important",
      },
      {
        value: 1440,
        label: "Hours",
        caption: "Thoughts that found a place to stay",
      },
      {
        value: 86400,
        label: "Minutes",
        caption: "Small moments that quietly mattered",
      },
      {
        value: 5184000,
        label: "Seconds",
        caption: "Each one bringing me closer to you",
      },
    ],
    reflection: "Some things can't be measured — only felt.",
    button: "Next",
  },
  meaningNote: {
    text: "I never meant to count the days.\n\nI just found myself waiting for you,\nthinking about you,\nfeeling closer without trying.\n\nSomewhere between then and now,\nthese sixty days became something I’ll always remember —\nbecause they led me to you.",
    button: "Next",
  },
  surprise: {
    text: "Loving you isn’t something I fall into.\n It’s something I choose — every single day.",
    button: "Reveal",
  },
  forever: {
    heading: "60 days was only the start.",
    subtext:
      "Somewhere along the way,\n choosing you became effortless.\n And it still is.",
    button: "Next",
  },
  closure: {
    message:
      "Thank you for being here.\nFor your presence.\nFor the care you gave without being asked.\nThese days mattered because of you.\nBecause we chose each other in them.\nAnd whatever comes next,\nI’m grateful it’s with you.",
    ctaStart: "Begin again → ⭐ best day ever",
    ctaHome: "Home",
  },
  video: {
    title: "A moment captured",
    subtitle: "Watch something close to my heart",
    playPrompt: "Press play when you're ready",
    playingPrompt: "Let this moment speak for itself",
    continueButton: "Continue",
    finishButton: "Finish watching first",
  },
};
